import React from 'react'
import {Field, reduxForm} from 'redux-form'
import {connect} from 'react-redux'

let CustomerForm = props => {
  const {handleSubmit, cancel, submitting} = props;

  return (
    <form onSubmit={handleSubmit}>
      <div className="modal-body">
        <div className="form-group">
          <label htmlFor="email">Email Address (Provide a valid e-mail address)</label>
          <Field className="form-control" name="email" component="input" type="text"/>
        </div>
        <div className="form-group">
          <label htmlFor="merchantCustomerId">Merchant Customer Id</label>
          <Field className="form-control" name="merchantCustomerId" component="input" type="text"/>
        </div>
      </div>
      <div className="modal-footer">
        <button type="submit" className="btn btn-primary col-xs-4 m-l pull-right" disabled={submitting}>
          <span className="btn-text">Create a customer</span>
        </button>
        <button type="button" className="btn btn-default col-xs-4 pull-right" onClick={cancel}>
          <span className="btn-text">Cancel</span>
        </button>
      </div>
    </form>
  )
};

CustomerForm = reduxForm({
  form: 'customer'
})(CustomerForm);

CustomerForm = connect(
  state => {
    const initialValues = {
      email: 'test@test',
      merchantCustomerId: 'Merchant_Customer_Id'
    };

    return {
      initialValues
    };
  }
)(CustomerForm);

export default CustomerForm;



// WEBPACK FOOTER //
// ./src/order/subforms/customer/CustomerForm.js